 <div class="container justify-content-center">
 <h2 style="color: #E0FFFF;">PER GLI UTENTI IN POSSESSO DEL COUPON O CODICE PROMOZIONALE E' IMPORTANTE INSERIRE I DATI PRIMA DELL'ATTIVAZIONE DEL SERVIZIO DESIDERATO.</h2>
 </div>
 <div class="row">
     <div class="col-4"></div>
     <div class="col-4"><button class="btn btn-primary btn-block mb-1" (click)="openCoupon(couponcontent)" type="submit">Inserisci Coupon</button></div>
     <div class="col-4"></div>
 </div>
 <h1  align='center' class="servizititle"><b>PROTOCOLLO BODY REVOLUTION</b></h1>
 <div class="container percorso rounded" style="margin-bottom: 10px;" *ngFor="let order of card">
     <h1  align='center' class="percorsotitle" *ngIf="order.payload.doc.data().disable==0"><b>{{ order.payload.doc.data().title }}</b> </h1>
     <h2  align='center' class="percorsosubtitle" *ngIf="order.payload.doc.data().disable==0"><b>{{ order.payload.doc.data().title2 }}</b> </h2>

     <div class="row">

         <div class="col-sm-6 col-md-6 col-xs-6 container"  *ngIf="order.payload.doc.data().disable==0">
             <div class="row justify-content-center desktop">
                 <div class="col-3  desktop"><img class="logoservizi" src="/assets/p2.jpg"></div>
             </div>
             <div class="row">
                 <div class="col-sm-1 col-md-1 col-xs-1"></div>
                 <div class="col-sm-10 col-md-10 col-xs-10" >
                    <img src="/assets/bodylayout.jpg"  style="width: 100%; length:100%;" *ngIf="order.payload.doc.data().disable==0">
                 </div>
                 <div class="col-sm-1 col-md-1 col-xs-1"></div>
             </div>

             <div class="row justify-content-center mobile">
                 <div class="col-3 mobile"><img class="logoservizi" src="/assets/p2.jpg"></div>
             </div>

         </div>

         <div class="col-sm-6 col-md-6 col-xs-6" *ngIf="order.payload.doc.data().disable==0">

             <div class="row justify-content-center desktop">
                 <div class="col-3 desktop" *ngIf="order.payload.doc.data().disable==0"><img  src="/assets/anamnesi.png" *ngIf="order.payload.doc.data().disable==0"></div>
             </div>

             <div class="row">
                <div class="col-sm-4 col-md-1 col-xs-4 mobile" *ngIf="order.payload.doc.data().disable==0"><img src="/assets/anamnesi.png" *ngIf="order.payload.doc.data().disable==0"></div>
                <div class="col-sm-6 col-md-10 col-xs-4" style="padding-bottom: 5%;" *ngIf="order.payload.doc.data().disable==0"> {{ order.payload.doc.data().description }}</div>
            </div>

             <div class="row justify-content-center desktop">
                 <div class="col-3 desktop" *ngIf="order.payload.doc.data().disable==0"><img  src="/assets/allenamento.png" *ngIf="order.payload.doc.data().disable==0"></div>
             </div>

            <div class="row">
                <div class="col-sm-4 col-md-1 col-xs-4 mobile" *ngIf="order.payload.doc.data().disable==0"><img  src="/assets/allenamento.png" *ngIf="order.payload.doc.data().disable==0">
                </div>
                <div class="col-sm-4 col-md-10 col-xs-4" style="padding-bottom: 5%;" *ngIf="order.payload.doc.data().disable==0"> {{ order.payload.doc.data().description2 }}</div>
            </div>

             <div class="row justify-content-center desktop">
                 <div class="col-3 desktop" *ngIf="order.payload.doc.data().disable==0"><img  src="/assets/update.png" *ngIf="order.payload.doc.data().disable==0 && order.payload.doc.data().scheda==0" ><img src="/assets/peso.png"  *ngIf="order.payload.doc.data().disable==0 && order.payload.doc.data().scheda==1"></div>
             </div>

             <div class="row">
                <div class="col-sm-3 col-md-1 col-xs-4 mobile" *ngIf="order.payload.doc.data().disable==0"><img  src="/assets/update.png" *ngIf="order.payload.doc.data().disable==0 && order.payload.doc.data().scheda==0" ><img src="/assets/peso.png" *ngIf="order.payload.doc.data().disable==0 && order.payload.doc.data().scheda==1"></div>
                <div class="col-sm-7 col-md-10 col-xs-4"  *ngIf="order.payload.doc.data().disable==0" style="padding-bottom: 5%;" >{{ order.payload.doc.data().description3 }}</div>
            </div>

             <div class="row  justify-content-center desktop">
                 <div class="col-3 desktop" *ngIf="order.payload.doc.data().disable==0"><img   src="/assets/peso.png" *ngIf="order.payload.doc.data().disable==0 && order.payload.doc.data().scheda==0"><img  src="/assets/web.png" *ngIf="order.payload.doc.data().disable==0 && order.payload.doc.data().scheda==1"></div>
             </div>

             <div class="row ">
                <div class="col-sm-4 col-md-1 col-xs-4 mobile" *ngIf="order.payload.doc.data().disable==0"><img  src="/assets/peso.png" *ngIf="order.payload.doc.data().disable==0 && order.payload.doc.data().scheda==0"><img src="/assets/web.png" *ngIf="order.payload.doc.data().disable==0 && order.payload.doc.data().scheda==1"></div>
                <div class="col-sm-4 col-md-10 col-xs-4" *ngIf="order.payload.doc.data().disable==0" style="padding-bottom: 5%;"> {{ order.payload.doc.data().description4 }}</div>
             </div>

             <div class="row  justify-content-center desktop">
                 <div class="col-3 desktop" *ngIf="order.payload.doc.data().disable==0 && order.payload.doc.data().scheda==0" ><img  src="/assets/web.png" *ngIf="order.payload.doc.data().disable==0 && order.payload.doc.data().scheda==0"></div>
             </div>

             <div class="row">
                 <div class="col-sm-4 col-md-1 col-xs-4 mobile" *ngIf="order.payload.doc.data().disable==0"><img  src="/assets/web.png" *ngIf="order.payload.doc.data().disable==0 && order.payload.doc.data().scheda==0"></div>
                 <div class="col-sm-4 col-md-10 col-xs-4" *ngIf="order.payload.doc.data().disable==0 && order.payload.doc.data().scheda==0" style="padding-bottom: 5%;"> {{ order.payload.doc.data().description5 }}</div>
             </div>


             <div class="row justify-content-center">
                 <div class="col-4" *ngIf="order.payload.doc.data().disable==0">

                     <button class="btn btn-primary"  style="margin-bottom: 2%;" *ngIf="order.payload.doc.data().disable==0" (click)="(openMail(contentwarrior,order.payload.doc.data().title))" type="submit">Attiva</button>

                 </div>
             </div>
             <p class="servizisottotitolo container">Si informa inoltre che il pagamento del servizio scelto, avverrà solo dopo aver effettuato la consulenza conoscitiva tramite videochiamata e dopo aver pattuito il piano di lavoro da iniziare insieme.</p>
         </div>
     </div>
     <div class="row justify-content-center">
         <div class="col-4" *ngIf="order.payload.doc.data().disable==0"><h2 class="percorsoprice" *ngIf="order.payload.doc.data().disable==0"><b>{{ order.payload.doc.data().price }}</b> €</h2></div>
     </div>
 </div>

<!-- MOBILE CAROUSEL -->
     <div class="col-xs-12 col-sm-4 col-md-4 desktop"  style="padding-bottom:3%; padding-top: 3%" >
         <ngb-carousel>
             <ng-template ngbSlide>
                 <img src="/assets/1.png" alt="1" class="d-block w-100">
             </ng-template>
             <ng-template ngbSlide>
                 <img src="/assets/2.png" alt="2" class="d-block w-100">
             </ng-template>
             <ng-template ngbSlide>
                 <img src="/assets/3.png" alt="3" class="d-block w-100">
             </ng-template>
             <ng-template ngbSlide>
                 <img src="/assets/4.png" alt="4" class="d-block w-100">
             </ng-template>
         </ngb-carousel>
     </div>
 <!-- DESKTOP CAROUSEL -->
 <div class="row justify-content-center mobile">
 <div class="col-4 mobile"  style="padding-bottom:3%; padding-top: 3%" >
     <ngb-carousel>
         <ng-template ngbSlide>
             <img src="/assets/1.png" alt="1" class="d-block w-100">
         </ng-template>
         <ng-template ngbSlide>
             <img src="/assets/2.png" alt="2" class="d-block w-100">
         </ng-template>
         <ng-template ngbSlide>
             <img src="/assets/3.png" alt="3" class="d-block w-100">
         </ng-template>
         <ng-template ngbSlide>
             <img src="/assets/4.png" alt="4" class="d-block w-100">
         </ng-template>
     </ngb-carousel>
 </div>
 </div>


 <ng-template #couponcontent let-c="close" let-d="dismiss">
   <div class="modal-header">
     <h4 class="modal-title" >Inserisci il codice coupon</h4>
     <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
       <span aria-hidden="true">&times;</span>
     </button>
   </div>
   <div class="modal-body">
     <form >
       <input  [(ngModel)]="cardcoupon.code"  name="coupon"  type="text" class="form-control mb-2" placeholder="Coupon"  required autofocus>
     </form>
   </div>
   <div class="modal-footer">
     <button class="btn btn-lg btn-primary btn-block mb-1" (click)="d(CaricaCoupon())" type="submit">Carica Coupon</button>
   </div>
 </ng-template>


 <ng-template #content let-c="close" let-d="dismiss">
   <div class="modal-header">
     <h4 class="modal-title" id="modal-basic-title">Inserisci i tuoi dati</h4>
     <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
       <span aria-hidden="true">&times;</span>
     </button>
   </div>
   <div class="modal-body">
     <form #signupForm = "ngForm">
         <input  [(ngModel)]="utente.nome" name="nome"  type="text" class="form-control mb-2" placeholder="Nome" required autofocus>
         <input  [(ngModel)]="utente.cognome" name="cognome"  type="text" class="form-control mb-2" placeholder="Cognome"  required autofocus>
         <input  [(ngModel)]="utente.cellulare" name="cellulare"  type="number" class="form-control mb-2" placeholder="Cellulare"  required autofocus>
         <input  [(ngModel)]="utente.email"  name="email"  type="text" class="form-control mb-2" placeholder="Email"  required autofocus>
         <input  [(ngModel)]="utente.eta" name="eta"  type="number" class="form-control mb-2" placeholder="Eta"  required autofocus>
       <input  [(ngModel)]="utente.sesso" name="sesso"  type="text" class="form-control mb-2" placeholder="Sesso" required  autofocus>
       <input  [(ngModel)]="utente.altezza" name="altezza"  type="number" class="form-control mb-2" placeholder="Altezza" required  autofocus>
       <input  [(ngModel)]="utente.peso" name="peso"  type="number" class="form-control mb-2" placeholder="Peso" required  autofocus>
       <input  [(ngModel)]="utente.problemarticolari" name="problematichearticolari"  type="text" class="form-control mb-2" placeholder="Problematiche Articolari"  autofocus>
       <input  [(ngModel)]="utente.patologie" name="patologie"  type="text" class="form-control mb-2" placeholder="Patologie"  autofocus>
       <input  [(ngModel)]="utente.farmaci" name="farmaci"  type="text" class="form-control mb-2" placeholder="Farmaci"  autofocus>
       <input  [(ngModel)]="utente.infoextra"  name="infoextra"  type="text" class="form-control mb-2" placeholder="Info Extra"  autofocus>
       <input  [(ngModel)]="utente.attrezzi" name="attrezzi"  type="text" class="form-control mb-2" placeholder="Attrezzi in Casa"  autofocus>
       <input  [(ngModel)]="utente.obiettivo" name="obiettivo"  type="text" class="form-control mb-2" placeholder="Obiettivo"  autofocus>
     </form>
   </div>
   <div class="modal-footer">
     <!--<ngx-paypal [config]="payPalConfig" ></ngx-paypal>-->
     <ngx-paypal *ngIf="this.utente.email!=null && this.utente.nome!=null && this.utente.cellulare!=null" [config]="payPalConfig" ></ngx-paypal>
   </div>
 </ng-template>


 <ng-template #contentwarrior let-c="close" let-d="dismiss">
   <div class="modal-header">
     <h4 class="modal-title" >Inserisci i dati:</h4>
     <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
       <span aria-hidden="true">&times;</span>
     </button>
   </div>
   <div class="modal-body">
     <form>
         <input  [(ngModel)]="utente.nome" name="nome"  type="text" class="form-control mb-2" placeholder="Nome" required autofocus>
         <input  [(ngModel)]="utente.cognome" name="cognome"  type="text" class="form-control mb-2" placeholder="Cognome"  required autofocus>
         <input  [(ngModel)]="utente.cellulare" name="cellulare"  type="number" class="form-control mb-2" placeholder="Cellulare"  required autofocus>
         <input  [(ngModel)]="utente.email"  name="email"  type="text" class="form-control mb-2" placeholder="Email"  required autofocus>
       <p class="servizicard">Dati per la fatturazione: </p>
       <input  [(ngModel)]="utente.nomef" name="nome"  type="text" class="form-control mb-2" placeholder="Nome Cognome" required autofocus>
       <input  [(ngModel)]="utente.indirizzo" name="Via"  type="text" class="form-control mb-2" placeholder="Indirizzo"  required autofocus>
       <input  [(ngModel)]="utente.cap" name="Via"  type="text" class="form-control mb-2" placeholder="CAP"  required autofocus>
       <input  [(ngModel)]="utente.citta" name="Citta"  type="text" class="form-control mb-2" placeholder="Citta"  required autofocus>
       <input  [(ngModel)]="utente.comune" name="Comune"  type="text" class="form-control mb-2" placeholder="Comune"  required autofocus>
       <input  [(ngModel)]="utente.cf" name="Codice Fiscale"  type="text" class="form-control mb-2" placeholder="Codice Fiscale o P.IVA"  required autofocus>
     </form>
   </div>
   <div class="modal-footer">
     <button class="btn btn-lg btn-primary btn-block mb-1" (click)="d(InviaMail(utente))" type="submit">Contattami</button>
   </div>
 </ng-template>
